import { addDays, format } from "date-fns";

export const handleKeyDown = (event) => {
  if (event.key === "Enter") {
    // Si la tecla presionada es Enter, realizamos alguna acción, como enviar el formulario
    // Por ejemplo, aquí podrías llamar a una función para enviar la consulta al backend
    console.log("Se presionó la tecla Enter");
    return true
  }
  return false
};

const buildName = (customer) => customer?.name ? customer?.name[0]  + " " + customer?.name[1] : document.getElementById("customerName")?.value;

const getValuesById = {
  identification: () => document.getElementById("customerIdentification"),
  full_name : () =>  document.getElementById("customerName"),
  email : () =>  document.getElementById("customerEmail"),
  phone : () =>  document.getElementById("customerPhone"),
  obs : () =>  document.getElementById("observations"),
  pending : () =>  document.getElementById("pending"),
}


export const buildPayload = ({ total, customer, services, customerType, signature }) => {
  const customer_identification = getValuesById.identification().value || '';
  const customer_full_name = buildName(customer) || getValuesById.full_name().value; 
  const customer_email = getValuesById.email().value || '';
  const customer_phone = getValuesById.phone().value || '';
  const customer_id_sigo = customer?.id || 'N/A';
  const customer_email_to_send = customer?.emailToSend || 'N/A'
  const customer_type = customerType
  const observations = `observación: ${getValuesById.obs().value} - pendiente: ${getValuesById.pending().value}`;

  return {
    customer_identification,
    customer_full_name,
    customer_email,
    customer_phone,
    customer_id_sigo,
    customer_email_to_send,
    customer_type,
    items: services,
    status: "Pendiente",
    payments: [
      {
        id: 542,
        value: total,
        due_date: format(addDays(new Date(), 30), "yyyy-MM-dd"),
      },
    ],
    observations,
    signature
  };
};

export const restartForm = () =>{
  getValuesById.email().value = ""
  if (getValuesById.full_name()) getValuesById.full_name().value = "";
  getValuesById.phone().value = ""
  getValuesById.identification().value = ""
  getValuesById.obs().value = ""
  getValuesById.pending().value = ""
}

const handleSubmit = async (e) => {
  try {
    setLoading(true);
    e.preventDefault();
    
    const obs = document.getElementById("observations");
    const pending = document.getElementById("pending");
    const observations = `observación: ${obs?.value} - pendiente: ${pending?.value}`;

    const payload = buildPayload({
      total,
      customer,
      services,
      observations,
    });

    await storeRemissions(total, payload.customer, payload.items, payload.observations);
    clearService();
    obs.value = "";
    pending.value = "";
    Toast.fire({
      icon: "success",
      title: "Registro guardado exitosamente",
    });
    sessionStorage.clear();
  } catch (error) {
    console.log("error", error);
  } finally {
    setLoading(false);
  }
};

